<template>
  <button @click="$emit('click', $event)" class="flex-row align-items-center gap-xs button-filter">
    <FilterVariantIcon class="icon-size-lg fill-primary"/>
    filter
    <span v-if="filterCount">({{filterCount}})</span>
  </button>
</template>

<script>
export default {
  name: "FilterButton",
  emits: ['click'],
  props: {
    filterCount: {
      type: Number,
      required: false,
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.button-filter {
  border: 0;
  outline: 0;
  color: $brand-primary;
  background-color: transparent;
}
</style>
